import React, { lazy, Suspense } from "react";
import Layout from "../layout/layout";
import Footer from "../components/Footer";
import ThemeSwitch from "../components/theme-switch";
import { useTheme } from "../context/theme-context";
import { ScrollProgress } from "../components/ScrollProgress";
// import Divider from "../components/Divider";
import ProjectSlider from "../components/ProjectSlider";
import Experience from "../components/Experience";

const LazyBannerQuote = lazy(() => import("../components/BannerQuote"));
const LazySiteBarRight = lazy(() => import("../components/SideBarRight"));
const LazySiteBarLeft = lazy(() => import("../components/SiteBarLeft"));
const LazySkill = lazy(() => import("../components/Skill"));
// const LazyAboutMe = lazy(() => import("../components/AboutMe"));
const LazyContact = lazy(() => import("../components/Contact"));
const LazyHeaderIntro = lazy(() => import("../components/HeaderIntro"));
const LazyRadialGradient = lazy(() => import("../components/RadialGradient"));
const LazyBrands = lazy(() => import("../components/Brands"));
const LazyCertifications = lazy(() => import("../components/Certifications"));
// const LazyTraveler = lazy(() => import("../components/Traveler"));
// import RadialGradient from "../components/RadialGradient";

const Home: React.FC = () => {
  const { theme } = useTheme();

  return (
    <>
      <Layout>
        <ThemeSwitch />
        <LazyRadialGradient
          opacity="opacity-30"
          scale="scale-y-100"
          position="-top-24"
        />
        <header className="h-screen">
          <ScrollProgress
            position={"left"}
            color={"orange"}
            height={10}
            smoothness={true}
          />
          <Suspense fallback={<div>Loading...</div>}>
            <LazySiteBarLeft />
            <LazyHeaderIntro />
            <LazySiteBarRight />
          </Suspense>
        </header>
        <main className="relative">
          <Suspense fallback={<div>Loading...</div>}>
            <LazyBannerQuote
              style={"withBG"}
              quoteIndex={0}
              containerType="quote"
            />

            <ProjectSlider />
            {/* <LazyTraveler /> */}
            <LazyBrands />
            
            {/* <Divider
              thickness="0.25rem"
              direction="outer-right-to-inner-left"
              color="black"
              height="small"
              dividerStyle="dashed"
            /> */}
            <Experience />

            {/* <Divider
              thickness="0.25rem"
              direction="inner-right-to-middle"
              color="black"
              height="middle"
              dividerStyle="dashed"
            /> */}

            <LazySkill />

            <LazyCertifications />

            {/* <Divider
              thickness="0.25rem"
              direction="middle"
              color="black"
              height="extraLarge"
              dividerStyle="dashed"
            /> */}

            <LazyBannerQuote
              style={"noBG"}
              quoteIndex={1}
              containerType="statement"
            />
            
            <div className="relative -mb-24 pb-32 -mt-10">
              {/* <LazyRadialGradient
                opacity={theme === "light" ? "opacity-30" : "opacity-30"}
                scale="scale-y-100"
                position="-top-24"
              /> */}
              {/* <Divider
                thickness="0.25rem"
                direction="middle-to-inner-left"
                color="black"
                height="middle"
                dividerStyle="dashed"
              /> */}

              {/* <LazyAboutMe />
              <Divider
                thickness="0.25rem"
                direction="inner-left-to-middle"
                color="black"
                height="middle"
                dividerStyle="dashed"
              /> */}

              <LazyContact />
            </div>
          </Suspense>
        </main>
        <Footer />
      </Layout>
    </>
  );
};

export default Home;
